import { createSlice } from '@reduxjs/toolkit';
import { login, logout } from './operations';

const initialState = {
  isLoggedIn: false,
  token: null,
};

const adminSlice = createSlice({
  name: 'admin',
  initialState: initialState,
  reducers: {
    resetAuth: state => {
      Object.keys(initialState).forEach(key => {
        state[key] = initialState[key];
      });
    },
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(login.pending, state => {
        state.isLoading = true;
        state.message = '';
        state.status = '';
      })
      .addCase(login.fulfilled, (state, action) => {
        const payload = action.payload ?? {};
        state.token = payload.token ?? state.token;
        state.isLoggedIn = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload;
        state.status = 'error';
      })
      .addCase(logout.fulfilled, state => {
        Object.keys(initialState).forEach(key => {
          state[key] = initialState[key];
        });
      });
  },
});

export const { resetAuth, setIsLoggedIn } = adminSlice.actions;

export const adminReducer = adminSlice.reducer;
